import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { from } from "rxjs";
import { map } from "rxjs/operators";
import { SaveService } from '../services/save.service';
import { ApiService } from '../services/api.service';
import { Router, NavigationEnd } from "@angular/router";
import { NgForm } from '@angular/forms';
@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.css"],
  providers: [ApiService,SaveService]
})
export class ContactUsComponent implements OnInit {
  emptyInput: boolean = false;
  emptyEmail: boolean = false;
  invalidEmail: boolean = false;
  emptyMessage: boolean = false;
  emptyCheckbox: boolean = false;
  submitLoader: boolean = false;
  emailmodel:any='';
  recaptchaStr = '';
  public src = '../../../assets/images/contact-us-bg.jpg';
  constructor(private apiService: ApiService, public router: Router) {
    this.router.events.subscribe((ev:any) => {
      if (ev instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    
  }

  /* focus validation */
  focusValidation(inputField) {
    if (inputField == "name") {
      this.emptyInput = false;
      $("#name_").removeAttr("style");
    }
    if (inputField == "email") {
      this.emptyEmail = false;
      this.invalidEmail = false;
      $("#email_").removeAttr("style");
    }
    if (inputField == "message") {
      this.emptyMessage = false;
      $("#message").removeAttr("style");
    }
  }

  checkboxFocusValidation() {
    if ($('input[type="checkbox"]').prop("checked") == true) {
      this.emptyCheckbox = false;
    } else {
      this.emptyCheckbox = true;
    }
  }

  /* form validation */
  validate() {
    var name = $("#name_").val();
    var email = $("#email_").val();
    var message = $("#message").val();
    var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    /* name */
    if (name == null || name == undefined || name == '') {
      this.emptyInput = true;
      $("#name_").css("border-color", "red");
    }

    /* email */
    if (!this.emailmodel.match(emailReg) && email != "") {
      this.emptyEmail = false;
      this.invalidEmail = true;
      $("#email_").css("border-color", "red");
      $("#email").focus();
    }
    if (email == null || email == undefined || email == '') {
      this.emptyEmail = true;
      $("#email_").css("border-color", "red");
    }

    /* message */
    if (message == null || message == undefined || message == '') {
      this.emptyMessage = true;
      $("#message").css("border-color", "red");
    }

    if (!$('input[type="checkbox"]').prop("checked") == true) {
      this.emptyCheckbox = true;
    }

    if (
      !(name == null || name == undefined || name == '') &&
      !(email == null || email == undefined || email == '') &&
      !(emailReg.test(this.emailmodel) == false) &&
      !(message == null || message == undefined || message == '') &&
      $('input[type="checkbox"]').prop("checked") == true
    ) {
      this.submitLoader = true;
      this.apiService
        .sendEmailContact(email, name, message)
        .pipe(map(res => res.json()))
        .subscribe(data => {
          if ((data[0].statuscode == 1)) {
            $("#name_").val("");
            $("#email_").val("");
            $("#message").val("");
            $("#contactsucess").show();
            setTimeout(() => {
              $("#contactsucess").fadeOut("slow");
            }, 2000);
            this.submitLoader = false;
          }else {
            this.submitLoader = false;
            $("#contactError").show();
          }
        });
    }else {
      this.submitLoader = false;
    }
  }
  /* form submission */
  // FormSubmit() {
  //   try {
  //     $.ajax({
  //       type: "POST",
  //       url: "http://marriagepartyinvitation.com/contact-form-handler.php",
  //       data: $("form").serialize(),
  //       success: function(data) {
  //         console.log("done");
  //       }
  //     });
  //   } catch (e) {
  //     alert("You messed something up!");
  //   }
  // }

  ngOnInit() {
  }
  onLoginClick(captchaRef: any): void {
    if (this.recaptchaStr) {
      captchaRef.reset();
    }
    captchaRef.execute()

  }
  public resolved(captchaResponse: string): void {
    // ;
    console.log(this.recaptchaStr);
    
    this.recaptchaStr = captchaResponse;
    if (this.recaptchaStr) {
      // ;
    }

  }
  errored() {
    console.warn(`reCAPTCHA error encountered`);
  }
}
